"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'avatar.preview.title': '头像预览',
    'avatar.preview.edit': '编辑头像',
    'avatar.preview.back': '返回列表',
    'avatar.preview.not_provided': '未提供',
    'avatar.preview.section.basic_info': '基本信息',
    'avatar.preview.section.logo': '头像标志',
    'avatar.preview.section.description': '描述',
    'avatar.preview.section.ai_model': 'AI模型配置',
    'avatar.preview.section.knowledge': '知识库',
    'avatar.preview.section.settings': '头像设置',
    'avatar.preview.section.validation': '配置状态',
    'avatar.preview.logo.not_uploaded': '未上传标志',
    'avatar.preview.provider': '提供者',
    'avatar.preview.cost': '成本',
    'avatar.preview.model.not_selected': '未选择AI模型 - 这是必需的！',
    'avatar.preview.knowledge.entries_selected': '个知识条目已选择',
    'avatar.preview.knowledge.none_selected': '未选择知识库条目',
    'avatar.preview.validation.status': '配置验证',
    'avatar.preview.validation.complete': '所有必需字段已完成',
    'avatar.preview.validation.incomplete': '缺少一些必需字段',
    'avatar.preview.no_data': '没有可用的头像数据',
    'avatar.preview.error.load_failed': '加载头像预览失败',
    'avatar.preview.voice.not_selected': '未选择语音',
    'avatar.preview.unnamed': '未命名头像',
    'avatar.preview.required': '必需的',
    'avatar.preview.gender.not_selected': '未选择性别',
    'avatar.preview.section.conversations': '对话',
    'avatar.preview.conversations.empty': '该头像暂无对话',
    'avatar.preview.conversations.untitled': '无标题对话',
};
